import { render, staticRenderFns } from "./PaymentAttributeDetailCreate.vue?vue&type=template&id=a462f978"
import script from "../../controllers/payment_att_detail/payment-attribute-detail-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/payment_att_detail/payment-attribute-detail-create.js?vue&type=script&lang=js&external"
import style0 from "./PaymentAttributeDetailCreate.vue?vue&type=style&index=0&id=a462f978&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports